/**
    Nav bar on scroll
*/
const menu = document.getElementById('nav');

function stickyHeader() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        menu.classList.add("nav__scrolled");

    } else {
        menu.classList.remove("nav__scrolled");
    }
}

window.onscroll = function () {
    stickyHeader();
};

const burgerIcon = document.getElementById('burger');

burgerIcon.onclick = function () {
    menu.classList.toggle("menu__open");
};